<mat-card class="base-container" [attr.data-cy]="generateDataCyId('-card')">
  <ng-content></ng-content>
</mat-card>
